import React from 'react';
import {Flex} from '/app/src/component';
import style from './style.css';

class ToogleInput extends React.Component {
    constructor(props){
        super(props);
        this._renderToogles = this._renderToogles.bind(this)
        this._handleToogle = this._handleToogle.bind(this)
    }

    _handleToogle(value){
        return (event) => {
            let activeValues = this.props.active
            // if the button is active
            if(activeValues.indexOf(value) > -1){ // then we remove and call onChange handle
                activeValues = activeValues.filter((item) => item !== value)
            // if the button is inactive
            }else{ // then we add and call onChange
                if(this.props.singleInput){
                    activeValues = [value]
                }else{
                    activeValues.push(value)
                }
            }
            event.target.value = activeValues
            event.target.name = this.props.name
            this.props.onChange(event)
        }
    }
    _renderToogles(values, initialActive){
        var toogles = []
        values.forEach((item) => {
            let itemStyle = style.ToogleItem
            // props to start the inial active value
            if(initialActive.indexOf(item.value) > -1){
                itemStyle = style.ToogleItemActive
            }
            toogles.push(
                <Flex key={item.label} className={itemStyle}
                hAlignContent='center' vAlignContent='center'
                name={item.label} onClick={this._handleToogle(item.value)}
                >
                     {item.label}
                </Flex>
            )
        })
        return toogles

    }
    render() {
        let {values, active, singleInput, ...rest} = this.props
        return(
            <Flex column className={style.InformationFormsWrapper} width='100%' {...rest}>
                <Flex width='100%' wrap>
                    {this._renderToogles(values, active)}
                </Flex>
            </Flex>
        );
    }
}
export default ToogleInput;



// WEBPACK FOOTER //
// ./src/component/Forms/ToogleInput/index.js